import React, { useState, useEffect } from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import qs from 'query-string';
import placeholderBackground from '../../../../assets/images/placeholder-background.png';

import { newFetch, GET, PUT } from '../../../../helpers/fetch';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../config';

const { SERVER_URL } = config;

const CollectionDetail = () => {
  const history = useHistory();
  const { cart_id } = useParams();
  const [cart, setCart] = useState(null);
  const [associate, setAssociate] = useState(null);

  const fetchCart = async () => {
    let api_path = `/reward/cart/${cart_id}`;
    let response = await newFetch(GET, api_path);

    response.success && setCart(response.data);
  };

  const fetchAssociate = async (associate_id) => {
    let api_path = `/associate/${associate_id}`;
    let response = await newFetch(GET, api_path);

    response.success && setAssociate(response.data);
  };

  const handleSetStatus = async (key) => {
    key = parseInt(key);
    switch (key) {
      case 1:
        let api_path_collected = `/reward/cart/${cart.id}/mark_collected_stat`;
        let response_collected = await newFetch(PUT, api_path_collected, {
          is_collected: 1,
        });

        if (response_collected.success) {
          fetchCart();
        } else {
          ToastUtil.error(response_collected.message);
        }
        break;
      case 2:
        let api_path_mailed = `/reward/cart/${cart.id}/mark_mailed`;
        let response_mailed = await newFetch(PUT, api_path_mailed, {
          is_mailed: true,
        });

        if (response_mailed.success) {
          fetchCart();
        } else {
          ToastUtil.error(response_mailed.message);
        }
        break;
      case 4:
        let api_path_cancelled = `/reward/cart/${cart.id}/mark_collected_stat`;
        let response_cancelled = await newFetch(PUT, api_path_cancelled, {
          is_collected: 3,
        });

        if (response_cancelled.success) {
          fetchCart();
        } else {
          ToastUtil.error(response_cancelled.message);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    cart_id && fetchCart();
  }, [cart_id]);

  useEffect(() => {
    cart && fetchAssociate(cart.associate_id);
  }, [cart]);

  return cart ? (
    <div
      className="d-flex flex-column"
      style={{ padding: '3rem 3rem 6rem 3rem' }}
    >
      <NavLink
        to="/rewards/collections"
        className="text-decoration-none"
        style={{ color: 'inherit' }}
      >
        <div style={{ color: '#5156BE' }}>
          <i className="fas fa-chevron-left pe-2"></i>Back to Collection
          Management
        </div>
      </NavLink>
      <div className="d-flex justify-content-between align-items-center pt-4">
        <h5>Cart ID: {cart.id.toString().padStart(8, 0)}</h5>
      </div>
      <div className="d-flex" style={{ marginTop: '2rem' }}>
        <div className="d-flex flex-column flex-grow-1 bg-white adjust-shadow rounded">
          <div className="p-4 d-flex flex-column">
            <div className="d-flex flex-row border-bottom pb-4 justify-content-between">
              <div className="d-flex flex-column">
                <div className="text-muted">Associate</div>
                <div
                  className="text-brand fw-bold"
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    history.push({
                      pathname: `/associates/associate/${cart.associate_id}`,
                      search: qs.stringify({
                        tab: 'Rewards',
                      }),
                    })
                  }
                >
                  {associate &&
                    `${associate.first_name} ${associate.last_name}`}
                </div>
              </div>
              <div className="d-flex flex-column">
                <div className="text-muted text-end">Date Redeemed</div>
                <div>
                  {moment(cart.createdAt, 'YYYY-MM-DD HH:mm:ss').format(
                    'DD MMM YYYY, HH:mma'
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column px-4 pb-4">
            <div className="d-flex flex-column">
              {cart.items.length > 0 &&
                cart.items.map((item) => (
                  <div
                    key={item.id}
                    className="d-flex justify-content-between align-items-center mb-2 px-2"
                  >
                    <div
                      className="img-responsive"
                      style={{
                        position: 'relative',
                        background: `url(${
                          item && item.reward_item.images.length > 0
                            ? `${SERVER_URL}/${item.reward_item.images[0].url}`
                            : placeholderBackground
                        }) no-repeat center center`,
                        backgroundSize: 'contain',
                        height: '150px',
                        width: '150px',
                      }}
                    ></div>
                    <div className="d-flex flex-column flex-grow-1 ms-3">
                      <div className="p-0 m-0">
                        {item && item.reward_item.name}
                      </div>
                      <div className="text-brand mt-1">
                        {item && item.reward_item.type === 'redeemable'
                          ? `${
                              item.reward_item.redeem_points * item.quantity
                            } Points`
                          : 'Free'}
                      </div>
                      <div className="mt-1 text-muted">
                        x{item && item.quantity}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="d-flex flex-column border rounded p-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-muted">Items:</div>
                <div className="fw-bold text-brand">
                  {cart.items.reduce(
                    (cartTotal, cartItem) =>
                      cartTotal +
                      cartItem.quantity * cartItem.reward_item.redeem_points,
                    0
                  )}{' '}
                  Points
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-muted">Shipping:</div>
                <div className="fw-bold text-brand">
                  {cart.items.reduce(
                    (cartTotal, cartItem) =>
                      cartTotal +
                      cartItem.quantity * cartItem.reward_item.mailing_cost,
                    0
                  )}{' '}
                  Points
                </div>
              </div>
              <div
                className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top"
                style={{ fontSize: '1.25rem' }}
              >
                <div className="fw-bold">TOTAL:</div>
                <div className="fw-bold text-brand">{cart.total} POINTS</div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                <div className="text-muted">Shipping Address:</div>
                <div className="fw-bold">
                  {associate && associate.address_1
                    ? `${associate.address_1 ? associate.address_1 : ''}${
                        associate.address_2 ? `, ${associate.address_2}` : ''
                      }${associate.address_3 ? `, ${associate.address_3}` : ''}`
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex flex-column"
          style={{ minWidth: '250px', width: '250px', marginLeft: '2rem' }}
        >
          <strong>Status</strong>
          <div className="mt-2">
            <span
              className={`badge rounded-pill p-2 ${
                !cart.is_collected && !cart.is_mailing && !cart.is_cancelled
                  ? 'text-bg-warning'
                  : !cart.is_mailed && cart.is_mailing
                  ? 'text-bg-warning'
                  : cart.is_mailed && cart.is_mailing
                  ? 'text-bg-success'
                  : cart.is_collected == 1
                  ? 'text-bg-success'
                  : cart.is_collected == 3
                  ? 'text-bg-danger'
                  : 'text-bg-warning'
              }`}
            >
              {!cart.is_collected && !cart.is_mailing && !cart.is_cancelled
                ? 'Pending Collection'
                : !cart.is_mailed && cart.is_mailing
                ? 'Pending Mailing'
                : cart.is_mailed && cart.is_mailing
                ? 'Mailed'
                : cart.is_collected == 1
                ? 'Collected'
                : cart.is_collected == 3
                ? 'Cancelled'
                : ''}
            </span>
          </div>
          <strong className="mt-4">Set Status</strong>
          <select
            name="ttAction"
            id="ttAction"
            className="form-select mt-2 adjust-fs rounded-1"
            value={
              !cart.is_collected && !cart.is_mailing
                ? 0
                : !cart.is_mailed && cart.is_mailing
                ? 0
                : cart.is_mailed && cart.is_mailing
                ? 2
                : cart.is_collected == 1
                ? 1
                : cart.is_collected == 3
                ? 4
                : 3
            }
            onChange={({ target: { value } }) => handleSetStatus(value)}
          >
            <option value={0}>Select</option>
            {!cart.is_collected && !cart.is_mailed && !cart.is_mailing ? (
              <option value={1}>Collected</option>
            ) : !cart.is_collected && cart.is_mailing ? (
              <option value={2}>Mailed</option>
            ) : (
              <option value={1}>Collected</option>
            )}
            <option value={4}>Cancelled</option>
          </select>
          {/* {
                            type === 'client'
                                ? <React.Fragment>
                                    {
                                        ticket && !ticket.action_id
                                            ? 'No action initiated'
                                            : (ticket && ticket.action.name)
                                    }
                                </React.Fragment>
                                : <select name="ttAction" id="ttAction" className="form-select mt-2" disabled={(ticket && ticket.status_id !== 2)} value={selectedAction} onChange={e => selectActionHandler(e)}>
                                    {(ticket && ticket.status_id !== 3 && !ticket.action_id) && <option value="0">Select</option>}
                                    {
                                        (actions && actions.length > 0)
                                            && actions.map(action => (
                                                <option key={action.id} value={action.id}>{action.name}</option>
                                            ))
                                    }
                                </select>
                        } */}
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default CollectionDetail;
